import { render } from "./LatestArticles.vue?vue&type=template&id=9542af3e"
import script from "./LatestArticles.vue?vue&type=script&lang=js"
export * from "./LatestArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__